<mat-card appearance="outlined"> 
    <mat-card-content>
        <div>   
            <canvas id={{data.statisticsTemplateId}}></canvas>
        </div>
    </mat-card-content>
</mat-card>